<template>
	<transition name="splash">
		<div v-if="show" class="splash-screen">
			<div class="background-animation">
				<div
					v-for="i in 20"
					:key="i"
					class="particle"
					:style="getParticleStyle(i)"
				></div>
			</div>

			<div class="logo-container" :class="{ 'fade-out': fadeOut }">
				<svg
					class="logo-svg"
					width="321"
					height="174"
					viewBox="0 0 321 174"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<!-- Текст "АКАДЕМИЯ" - появляется после основного логотипа -->
					<g class="akademiya-text">
						<path
							data-c="white"
							d="M163.407 161.711H170.227L166.927 153.571H166.707L163.407 161.711ZM169.347 151.701L175.617 167.101H172.449L170.997 163.361H162.637L161.185 167.101H158.017L164.287 151.701H169.347ZM187.284 159.291L193.114 167.101H189.484L184.424 160.281H180.574V167.101H177.384V151.701H180.574V158.631H184.204L189.264 151.701H192.784L187.284 159.291ZM198.942 161.711H205.762L202.462 153.571H202.242L198.942 161.711ZM204.882 151.701L211.152 167.101H207.984L206.532 163.361H198.172L196.72 167.101H193.552L199.822 151.701H204.882ZM212.699 165.451C213.139 165.451 213.542 165.246 213.909 164.835C214.29 164.425 214.51 163.86 214.569 163.141L215.449 151.701H227.769V165.451H229.639V170.621H226.999L226.559 167.101H214.679L214.239 170.621H211.599V165.451H212.699ZM217.649 163.141C217.62 163.523 217.524 163.86 217.363 164.153C217.202 164.447 217.026 164.689 216.835 164.879C216.615 165.114 216.373 165.305 216.109 165.451H224.579V153.351H218.419L217.649 163.141ZM235.251 153.351V158.411H243.281V160.061H235.251V165.451H245.481V167.101H232.061V151.701H245.481V153.351H235.251ZM258.131 164.901H258.351L264.071 151.701H268.801V167.101H265.611V154.781H265.391L260.111 167.101H256.371L251.091 154.781H250.871V167.101H247.681V151.701H252.411L258.131 164.901ZM284.522 167.101V154.561H284.302L276.052 167.101H271.872V151.701H275.062V164.241H275.282L283.532 151.701H287.712V167.101H284.522ZM290.14 167.101L293.77 161.909C292.67 161.484 291.826 160.868 291.24 160.061C290.653 159.255 290.36 158.265 290.36 157.091C290.36 156.241 290.521 155.485 290.844 154.825C291.166 154.151 291.628 153.586 292.23 153.131C292.831 152.662 293.564 152.31 294.43 152.075C295.31 151.826 296.3 151.701 297.4 151.701H305.32V167.101H302.13V162.481H297.4H297.004L293.77 167.101H290.14ZM297.4 153.351C296.241 153.351 295.346 153.659 294.716 154.275C294.085 154.877 293.77 155.815 293.77 157.091C293.77 158.367 294.085 159.313 294.716 159.929C295.346 160.531 296.241 160.831 297.4 160.831H302.13V153.351H297.4Z"
							fill="white"
						/>
					</g>

					<!-- Основной логотип -->
					<g class="main-logo">
						<path
							data-c="#0095EC"
							d="M313.234 128.437H320.17V145H311.477V136.209H277.63V145H269.398V128.437H278.748C278.883 128.266 279.109 127.846 279.109 127.233V84.0205H313.234V128.437ZM287.803 128.437H304.541V91.3311H287.803V128.437Z"
							fill="#0095EC"
						/>
						<path
							data-c="#0095EC"
							d="M237.858 113.975L253.671 105.838V84.0202H262.827V135.746H253.671V115.044L237.858 123.181V135.746H229.164V83.5576H237.858V113.975Z"
							fill="#0095EC"
						/>
						<path
							data-c="#0095EC"
							d="M252.274 85.1362L252.132 85.2664L246.121 90.8183L245.996 90.9349L245.87 90.8183L239.859 85.2664L239.717 85.1362L242.759 82.0928L245.996 85.3314L249.232 82.0928L252.274 85.1362Z"
							fill="#0095EC"
						/>
						<path
							data-c="#0095EC"
							d="M209.657 84.4443C212.332 84.6876 214.192 85.9907 215.367 87.5361C216.495 89.0186 216.982 90.7 217.09 91.8818L217.099 91.9756V105.583L217.09 105.677C216.607 110.99 212.113 113.401 210.016 113.974L209.748 114.047H193.979V106.645H207.619C208.102 106.645 208.407 106.557 208.59 106.475C208.77 106.393 208.887 106.292 208.972 106.188C209.168 105.949 209.237 105.632 209.237 105.487V93.458C209.237 92.602 208.993 92.1966 208.849 92.0215C208.772 91.9292 208.699 91.8729 208.647 91.8389H193.747C193.168 91.8389 192.875 91.9464 192.751 92.0107C192.643 92.0668 192.605 92.1186 192.58 92.1631C192.545 92.2268 192.506 92.3392 192.494 92.5078C192.482 92.6789 192.502 92.8439 192.529 92.9531L192.591 93.2021V127.233C192.591 128.097 192.835 128.339 192.854 128.358C192.872 128.376 192.89 128.384 192.899 128.39H207.619C208.471 128.39 208.978 128.107 209.237 127.9V118.303H217.099V128.621C217.099 130.688 215.997 132.305 214.932 133.375C213.855 134.457 212.59 135.217 211.701 135.612L211.298 135.792H192.154L191.952 135.752C187.497 134.86 185.335 131.955 184.811 130.118L184.73 129.838V91.1455C184.73 89.1369 185.697 87.5976 186.724 86.5654C187.734 85.5499 188.924 84.8905 189.78 84.5693L190.133 84.4365H209.563L209.657 84.4443Z"
							fill="#0095EC"
						/>
						<path
							data-c="#0095EC"
							d="M168.805 83.5449C170.295 83.7803 172.524 84.5079 174.386 85.9316C176.253 87.3595 177.76 89.4957 177.76 92.5332V92.5352L177.297 130.011V130.032L177.292 130.054C176.818 132.11 174.543 136.224 169.236 136.224H153.314V128.421H168.216C168.268 128.345 168.342 128.206 168.409 127.993C168.499 127.71 168.573 127.306 168.573 126.77V92.5332C168.573 92.3339 168.512 92.0301 168.334 91.7822C168.163 91.5446 167.876 91.3448 167.387 91.3447H153.145C153.014 91.519 152.79 91.9619 152.79 92.6592V157.043H144.066V91.1318H144.068C144.148 89.8634 144.667 87.9705 145.974 86.3906C147.287 84.8027 149.386 83.542 152.59 83.542H168.789L168.805 83.5449Z"
							fill="#0095EC"
						/>
						<path
							data-c="white"
							d="M258.939 30.5361V77.7279H255.24V33.7748H234.432V72.6386C234.432 74.4892 233.045 77.2652 228.883 77.7279H223.797V74.4892H228.421C231.195 74.0266 230.733 72.6386 230.733 69.8626V30.5361H258.939Z"
							fill="white"
						/>
						<path
							data-c="white"
							d="M215.478 30.0732V77.265H211.779V33.3119H190.971V72.1757C190.971 74.0263 189.584 76.8023 185.422 77.265H180.336V74.0263H184.96C187.734 73.5637 187.272 72.1757 187.272 69.3997V30.0732H215.478Z"
							fill="white"
						/>
						<path
							data-c="white"
							d="M166.75 29.5947C169.345 29.5947 170.926 30.4237 171.841 31.8867C172.741 33.3269 172.97 35.3446 172.97 37.6602V37.7539C172.97 37.8153 172.969 37.9065 172.969 38.0254C172.968 38.2631 172.966 38.6119 172.965 39.0566C172.962 39.9467 172.957 41.2216 172.952 42.7578C172.942 45.8301 172.927 49.9508 172.913 54.1436C172.885 62.5296 172.856 71.2042 172.856 72.3604C172.857 73.5432 172.621 74.517 172.007 75.3154C171.395 76.1113 170.428 76.7076 169.021 77.1768C168.65 77.3003 168.073 77.3878 167.364 77.4512C166.65 77.515 165.785 77.5554 164.829 77.5771C162.917 77.6206 160.63 77.5911 158.433 77.5332C156.234 77.4753 154.123 77.3887 152.562 77.3164C151.781 77.2802 151.138 77.2481 150.689 77.2246C150.466 77.2129 150.29 77.2028 150.171 77.1963C150.111 77.193 150.065 77.1912 150.034 77.1895C150.019 77.1886 150.007 77.187 149.999 77.1865H149.987L149.98 77.1855C147.885 76.9948 146.487 75.9986 145.598 74.8291C144.713 73.6657 144.331 72.3334 144.251 71.4531L144.25 71.4434V58.0088L144.251 57.999C144.632 53.8086 148.212 51.821 149.946 51.3477L149.973 51.3398H163.608V54.9785H151.849C150.424 54.9785 149.558 55.4955 149.044 56.1201C148.523 56.753 148.35 57.5157 148.35 58.0176V70.0469C148.35 72.522 149.8 73.402 150.485 73.5479H165.721C166.627 73.5478 167.257 73.4056 167.697 73.1855C168.132 72.9679 168.389 72.6698 168.544 72.334C168.701 71.9928 168.757 71.6036 168.771 71.2031C168.786 70.7902 168.758 70.4189 168.758 70.0469C168.758 69.3528 168.767 60.9087 168.775 52.6387C168.78 48.5038 168.784 44.4123 168.787 41.3545C168.789 39.8255 168.79 38.5543 168.791 37.666C168.792 37.222 168.792 36.8732 168.792 36.6357C168.792 36.5173 168.793 36.4265 168.793 36.3652V36.2676C168.831 34.6861 168.389 33.9647 167.779 33.6113C167.463 33.4281 167.082 33.3322 166.655 33.2832C166.227 33.2341 165.768 33.2334 165.294 33.2334H152.312C152.078 33.2334 151.836 33.226 151.597 33.2188C151.356 33.2115 151.117 33.2051 150.882 33.2051C150.41 33.2051 149.969 33.234 149.592 33.3418C149.219 33.4485 148.916 33.6294 148.703 33.9297C148.489 34.2324 148.35 34.6792 148.35 35.3467V42.9492H144.25V35.0664C144.251 31.5173 147.136 29.5947 149.538 29.5947H166.75Z"
							fill="white"
						/>
						<path
							data-c="#0095EC"
							d="M122.998 157.306H115.137L114.674 32.3866L65.6602 0.462769H173.399L122.998 32.3866V157.306Z"
							fill="#0095EC"
						/>
						<path
							data-c="white"
							d="M93.8667 36.088C93.7126 34.3915 92.387 30.9061 88.3179 30.536H69.3593C68.1263 30.9987 65.6602 32.5717 65.6602 35.1627V73.5638C65.9684 74.6433 67.5098 76.9875 71.2089 77.7277H89.7049C91.0921 77.1109 93.8665 75.2294 93.8665 72.6384V67.5491H90.1673V72.6384C89.859 73.2553 88.6876 74.4891 86.4681 74.4891H71.6713C70.9007 74.4891 69.3594 73.8414 69.3596 71.2505V37.476C69.0513 36.2422 69.2671 33.7747 72.5964 33.7747H87.8555C88.6262 33.9289 90.1675 34.8851 90.1675 37.476V49.5052C90.1675 50.5848 89.4277 52.7439 86.4683 52.7439H74.9084V55.9825H88.3179C90.0134 55.5199 93.4968 53.5767 93.8667 49.5052V36.088Z"
							fill="white"
						/>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							data-c="white"
							d="M47.656 0.0253019V0.0198801H52.2799V77.7474H47.656V3.32811L29.3515 53.1648L29.4752 53.2262H29.3289L29.3153 53.2642L29.2124 53.2262H23.0675L22.9646 53.2642L22.951 53.2262H22.8047L22.9276 53.1648L4.62399 3.32811V77.7474H0V0.0198801H4.62399V0.0253019L7.42637 0L7.40109 0.0280129L26.14 51.0458L44.8789 0.0280129L44.8536 0L47.656 0.0253019ZM26.1327 52.0976L26.14 52.1003L26.1463 52.0976L26.14 52.0949L26.1327 52.0976Z"
							fill="white"
						/>
					</g>
				</svg>
			</div>

			<div class="loading-text" :class="{ visible: showText }">
				<span
					class="letter"
					v-for="(letter, i) in loadingLetters"
					:key="i"
					:style="{ animationDelay: `${i * 0.1}s` }"
				>
					{{ letter }}
				</span>
			</div>
		</div>
	</transition>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue'

const show = ref(true)
const fadeOut = ref(false)
const showText = ref(false)

const loadingLetters = computed(() => 'ЗАГРУЗКА'.split(''))

// Генерация случайных стилей для частиц
const getParticleStyle = _index => {
	const randomX = Math.random() * 100
	const randomY = Math.random() * 100
	const randomDelay = Math.random() * 2
	const randomDuration = 3 + Math.random() * 4

	return {
		left: `${randomX}%`,
		top: `${randomY}%`,
		animationDelay: `${randomDelay}s`,
		animationDuration: `${randomDuration}s`,
	}
}

onMounted(() => {
	document.documentElement.style.overflow = 'hidden'
	document.body.style.overflow = 'hidden'

	//  каждому path задаём свой цвет для контура (stroke)
	const paths = document.querySelectorAll('.main-logo path')
	paths.forEach(p => {
		const c = p.getAttribute('data-c') || p.getAttribute('fill') || 'white'
		p.style.color = c // для stroke: currentColor
		p.style.fill = 'transparent'
	})

	// через 1s (после прорисовки) возвращаем заливку своим цветом
	setTimeout(() => {
		paths.forEach(p => {
			const c = p.getAttribute('data-c') || p.getAttribute('fill') || 'white'
			p.style.fill = c
		})
	}, 1000)

	setTimeout(() => {
		showText.value = true
	}, 2000)
	setTimeout(() => {
		fadeOut.value = true
	}, 3000)
	setTimeout(() => {
		show.value = false
	}, 4000)
})

watch(show, isVisible => {
	if (!isVisible) {
		document.documentElement.style.overflow = ''
		document.body.style.overflow = ''
	}
})

onBeforeUnmount(() => {
	document.documentElement.style.overflow = ''
	document.body.style.overflow = ''
})
</script>

<style scoped>
.splash-screen {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: radial-gradient(
		circle at center,
		#2a2a2a 0%,
		#1a1a1a 50%,
		#0a0a0a 100%
	);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	z-index: 999999999;
	overflow: hidden;
}

/* Фоновая анимация частиц */
.background-animation {
	position: absolute;
	width: 100%;
	height: 100%;
	overflow: hidden;
}

.particle {
	position: absolute;
	width: 3px;
	height: 3px;
	background: rgba(255, 255, 255, 0.3);
	border-radius: 50%;
	animation: float 5s infinite ease-in-out;
}

@keyframes float {
	0%,
	100% {
		transform: translateY(0) translateX(0) scale(1);
		opacity: 0;
	}
	10% {
		opacity: 1;
	}
	90% {
		opacity: 1;
	}
	50% {
		transform: translateY(-50px) translateX(30px) scale(1.5);
	}
}

/* Контейнер логотипа */
.logo-container {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	animation: containerAppear 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
	transition: all 0.7s ease;
	left: -20px;
}

.logo-container.fade-out {
	opacity: 0;
	filter: blur(10px);
}

@keyframes containerAppear {
	0% {
		opacity: 0;
		transform: scale(0.5) rotate(-10deg);
	}
	60% {
		transform: scale(1.05) rotate(2deg);
	}
	100% {
		opacity: 1;
		transform: scale(1) rotate(0deg);
	}
}

.logo-svg {
	width: 100%;
	max-width: 400px;
	height: auto;
	display: block;
	margin: 0 auto;
	z-index: 2;
}

/* ===== АНИМАЦИЯ ОСНОВНОГО ЛОГОТИПА ===== */
/* Фаза 1 (0-1s): Контур → Заполнение */
.main-logo path {
	stroke: currentColor; /* цвет берём из CSS-переменной/inline */
	stroke-width: 0.7;
	fill: transparent; /* пока рисуем — заливки нет */
	stroke-dasharray: 1000;
	stroke-dashoffset: 1000;
	animation: drawMainLogo 1s ease-out forwards;
}

@keyframes drawMainLogo {
	0% {
		stroke-dashoffset: 1000;
		fill-opacity: 0;
		stroke-opacity: 1;
	}
	60% {
		stroke-dashoffset: 0;
		fill-opacity: 0;
		stroke-opacity: 1;
	}
	100% {
		stroke-dashoffset: 0;
		fill-opacity: 1;
		stroke-opacity: 0;
	}
}

/* ===== АНИМАЦИЯ "АКАДЕМИЯ" ===== */
/* Фаза 2 (1-2s): Появление после основного логотипа */
.akademiya-text {
	opacity: 0;
	animation: fadeInAkademiya 0.5s 1s ease-out forwards;
}

@keyframes fadeInAkademiya {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

/* Текст загрузки */
.loading-text {
	position: absolute;
	bottom: 15%;
	font-family: 'Poppins', sans-serif;
	font-size: 18px;
	font-weight: 600;
	letter-spacing: 8px;
	color: rgba(255, 255, 255, 0.8);
	opacity: 0;
	transition: opacity 0.5s ease;
}

.loading-text.visible {
	opacity: 1;
}

.letter {
	display: inline-block;
	animation: letterBounce 1s ease-in-out infinite;
}

@keyframes letterBounce {
	0%,
	100% {
		transform: translateY(0);
	}
	50% {
		transform: translateY(-10px);
	}
}

/* Transition для исчезновения всего экрана */
.splash-leave-active {
	transition: opacity 0.8s ease, transform 0.8s ease;
}

.splash-leave-to {
	opacity: 0;
	transform: scale(0.95);
}

/* ===== КОМПЕНСАЦИЯ ZOOM ДЛЯ ИЗОЛЯЦИИ КОМПОНЕНТА ===== */
/* Компенсирует zoom на body для разных разрешений */
/* Это делает SplashAnimate полностью независимым от стилей главной страницы */

/* Компенсация для экранов ≤1366px */
@media (max-width: 1366px) {
	.splash-screen {
		zoom: 1.406; /* 1 ÷ 0.711 ≈ 1.406 - компенсация zoom на body */
	}
}

/* Компенсация для экранов 1367-1600px (включая FullHD с масштабом 125%) */
@media (min-width: 1367px) and (max-width: 1600px) {
	.splash-screen {
		zoom: 1.176; /* 1 ÷ 0.85 ≈ 1.176 - компенсация zoom на body */
	}
}

/* Компенсация для 2560px с Windows 150% (браузер видит ~1707px) */
@media (min-width: 1601px) and (max-width: 1800px) {
	.splash-screen {
		zoom: 1.111; /* 1 ÷ 0.9 ≈ 1.111 - компенсация zoom на body */
	}
}

/* Компенсация для 2560px с Windows 100% (браузер видит 2560px) */
@media (min-width: 2301px) and (max-width: 2880px) {
	.splash-screen {
		zoom: 0.75; /* 1 ÷ 1.35 ≈ 0.667 - компенсация zoom на body */
	}
}

/* Экраны 1801-2300px - без компенсации, так как zoom на body = 1.0 */

@media (max-width: 768px) {
	.logo-svg {
		width: 90%;
	}

	.loading-text {
		font-size: 14px;
		letter-spacing: 5px;
	}
}
</style>
